<mat-tab-group #tabGroup>
  <mat-tab label="Subscribe">
    <mat-dialog-content>
      <div class="form-container">
        <mat-form-field>
          <mat-label>Email</mat-label>
          <input
            matInput
            #emailInput
            name="subscriptionEmail"
            ngDefaultControl
            [(ngModel)]="subscriptionEmail"
            type="email"
            (input)="validateEmail(emailInput.value)"
            title="Email"
            required="required"
            />
          @if (!isEmailValid) {
            <mat-error>
              Please enter a valid email address.
            </mat-error>
          }
        </mat-form-field>
        <h3>Announcement Types</h3>
        <mat-form-field>
          <mat-label>Announcement Types</mat-label>
          <mat-select
            name="selectedTypes"
            ngDefaultControl
            [(ngModel)]="selectedTypes"
            multiple
            >
            @for (type of announcementTypes; track type) {
              <mat-option [value]="type">{{
                type
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-raised-button class="button" (click)="onNoClick()">
        Cancel
      </button>
      <button
        mat-raised-button
        class="button"
        [disabled]="!isEmailValid"
        (click)="subscribe()"
        >
        Subscribe
      </button>
    </mat-dialog-actions>
  </mat-tab>
  <mat-tab label="Manage">
    <mat-dialog-content>
      <table
        #subscriptionsTable
        mat-table
        [dataSource]="subscriptions"
        multiTemplateDataRows
        matSort
        aria-describedby="subscriptions"
        >
        <ng-container matColumnDef="position">
          <th mat-header-cell *matHeaderCelLDef>No.</th>
          <td mat-cell *matCellDef="let element">{{ element.position }}</td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let element">{{ element.subscriberEmail }}</td>
        </ng-container>
        <ng-container matColumnDef="addedAnnouncementTypes">
          <th mat-header-cell *matHeaderCellDef>Subscribed Types</th>
          <td mat-cell *matCellDef="let element">
            {{ element.addedAnnouncementTypes }}
          </td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>Action</th>
          <td mat-cell *matCellDef="let element">
            <a mat-icon-button (click)="editSubscription(element)">
              <mat-icon style="color: #0093a1">edit</mat-icon>
            </a>
            <a mat-icon-button (click)="deleteSubscription(element)">
              <mat-icon style="color: red">delete_forever</mat-icon>
            </a>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </mat-dialog-content>
  </mat-tab>
</mat-tab-group>
